export default {
  ongoingActivities: [],
  ongoingActivitiesFetched: false
}



// WEBPACK FOOTER //
// ./src/store/modules/global/state.js